import { FC } from 'react';

import { Colors } from 'components/map/Styles';
import { hourglassCircleSvg } from 'components/map/icons';

import { InventeringPreliminar } from 'models';

import { AktivitetRegistreringsstatustypEnum } from 'enums';

import { formatDateWithTime } from 'utilities/dateUtilities';

export interface InventeringStatusSectionProps {
  inventeringPreliminar: InventeringPreliminar;
}

const InventeringStatusSection: FC<InventeringStatusSectionProps> = ({ inventeringPreliminar }) => {
  return (
    (inventeringPreliminar.aktivitet_registrering_status.registreringsstatustyp_id ===
      AktivitetRegistreringsstatustypEnum.INSKICKAD ||
      inventeringPreliminar.aktivitet_registrering_status.registreringsstatustyp_id ===
        AktivitetRegistreringsstatustypEnum.AVRAPPORTERAD) && (
      <div className="tw-mb-6 tw-border-2 tw-border-dashed tw-border-raa-green tw-p-3">
        <div className="tw-flex tw-items-center">
          <img
            src={`data:image/svg+xml,${encodeURIComponent(hourglassCircleSvg(Colors.RAA_GRAY_2, Colors.BLACK))}`}
            alt="Ikon för ej publicerad inventering"
            className="tw-mr-2 tw-h-6"
          />
          <span className="tw-grow tw-text-size-0.813 tw-text-raa-green">
            Publiceras efter granskning av personuppgifter och sekretess. Ärende{' '}
            {inventeringPreliminar.aktivitet_registrering_status.arendenummer}, inlämnat{' '}
            {formatDateWithTime(inventeringPreliminar.aktivitet_registrering_status.status_datum_inskickad)}
          </span>
        </div>
      </div>
    )
  );
};

export default InventeringStatusSection;
